import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Alert, Card, Form } from 'react-bootstrap';

const messageOf = (e, fallback) => e.response?.data?.message || (typeof e.response?.data === 'string' ? e.response.data : null) || fallback;

/**
 * Org Admin > Online Store > Show my products on ibigdo.com/shop: off until chosen. When on, the store's published products can be found by buyers on the products
 * page of ibigdo.com/shop; each opens in this store, where the sale is made as always. Needs the store switched on and a grievance officer named.
 */
export default function DirectorySettings({ storeSaved }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      setD((await axios.get('/api/store/directory')).data);
    } catch (e) {
      setD(null);
    }
  }, []);
  useEffect(() => { load(); }, [load, storeSaved]);

  const toggle = async (e) => {
    const want = e.target.checked;
    setBusy(true);
    try {
      setD((await axios.put('/api/store/directory', { listProducts: want })).data);
      toast.success(want ? 'Your products can now be found on ibigdo.com/shop.' : 'Your products are no longer shown on ibigdo.com/shop.');
    } catch (err) {
      toast.error(messageOf(err, 'Could not change this.'));
    } finally {
      setBusy(false);
    }
  };

  if (!storeSaved || !d) return null;
  return (
    <Card className="mt-3" data-testid="directory-settings">
      <Card.Body>
        <Card.Title as="h6">Show my products on ibigdo.com/shop</Card.Title>
        <p className="small text-muted">
          The products page of ibigdo.com/shop lets buyers browse products from many stores. When you switch this on, your published products can be found there, with your store&apos;s name and town.
          Buyers go on to <strong>your own store</strong> to buy: your prices, your delivery, your payment account and your invoice. iBigDo does not take a commission or handle the money. You can switch it off at any time.
        </p>
        {d.hidden && (
          <Alert variant="warning" className="py-2 small" data-testid="directory-hidden">
            iBigDo has taken your products off ibigdo.com/shop{d.hiddenReason ? ` (${d.hiddenReason})` : ''}. Your store and its address work as before. Write to us from Help &amp; Support to ask why or to have it put back.
          </Alert>
        )}
        <Form.Check type="switch" id="store-list-products" label="Show my products on ibigdo.com/shop" checked={d.listProducts} disabled={busy} onChange={toggle} data-testid="store-list-products" />
        <ul className="small text-muted mb-0 mt-2 ps-3">
          <li>{d.storeOn ? 'Your store is switched on.' : 'Switch your store on first.'}</li>
          <li>{d.hasGrievanceOfficer ? 'A grievance officer is named.' : 'Name a grievance officer (above): a buyer who finds your products here needs to know who to complain to.'}</li>
          <li>{d.productsPublished > 0 ? `${d.productsPublished} published ${d.productsPublished === 1 ? 'product is' : 'products are'} ready to be shown.` : 'Publish a product in Online Store > Products online for it to appear.'}</li>
        </ul>
      </Card.Body>
    </Card>
  );
}
